export default [
  {
    path: '/tools/checkTicket',
    component: () => import('../pages/tools/checkTicket.vue'),
    name: 'checkTicket',
    title: '核销工具',
    meta: {
      title: '核销工具',
    },
  },
]
